<template >
	<div class="upload-button" align="center">
		<input
			:style="{ 'font-size': touchSize + 'rem' }"
			type="file"
			value=""
			accept="image/*"
			:multiple="multiple"
			@change="bindchange_chooseImages"
		/>
		<!--capture="camera"-->
		<!--:multiple=multiple-->
	</div>
</template>

<script>
// import lrz from 'lrz';
import * as imageConversion from 'image-conversion';
import OCR_LOADING from '@/assets/images/ocr_loading.gif';
import { mapActions } from 'vuex';
import { blobToBase64 } from '@/utils/api';
export default {
	name: 'image-upload',

	props: {
		// 上传图片字段名
		fieldName: '',
		// 上传地址
		url: '',
		// 是否支持多选
		multiple: {
			type: Boolean,
			default: false
		},
		// 接口是否支持多传
		multiUpload: {
			type: Boolean,
			default: false
		},
		// 点击按钮的点击范围
		touchSize: {
			type: Number,
			default: 0.5
		},
		// 压缩选项, open默认开启
		lrzOptions: {
			type: Object,
			default: function () {
				return {
					quality: 0.7
				};
			}
		},
		// 上传其他参数
		data: {
			type: Object,
			default: function () {
				return {};
			}
		},
		// 限制张数
		maxCount: {
			type: Number,
			default: -1 //-1表示无限制
		},
		loadingMsg: {
			type: String,
			default: '正在识别'
		},
		handleHideTip: {
			type: Boolean,
			default: true
		}
	},

	methods: {
		...mapActions(['showTooltip', 'hideTooltip', 'identifyBusinessCard']),
		/**
		 *  绑定函数 -- 选择图片
		 */
		bindchange_chooseImages(e) {
			if (this.maxCount >= 0 && e.target.files.length > this.maxCount) {
				return this.$emit('chooseImages', '超过最大选择数量！');
			}

			this.parseImages(e.target.files)
				.then(res => {
					e.target.value = '';
					this.$emit('chooseImages', res);
				})
				.catch(e => {
					console.log(e);
				});
		},

		/**
		 *  上传图片upload上传
		 */
		uploadImages(images) {
			if (this.multiUpload) {
			} else {
				let promises = [];
				images.forEach((v, i) => {
					if (!v.upload) {
						promises.push(this.uploadSingleImage(v.file));
					}
				});
				return Promise.all(promises);
			}
		},
		/**
		 *  上传图片oss上传
		 */
		uploadImagesOSS(images) {
			if (this.multiUpload) {
			} else {
				let promises = [];
				images.forEach((v, i) => {
					if (!v.upload) {
						promises.push(this.uploadSingleImageOSS(v.file));
					}
				});
				return Promise.all(promises);
			}
		},

		// 名片识别
		uploadImagesOCR(images) {
			if (this.multiUpload) {
			} else {
				let promises = [];
				images.forEach((v, i) => {
					if (!v.upload) {
						promises.push(this.uploadSingleImageOCR(v.file));
					}
				});
				return Promise.all(promises);
			}
		},

		/**
		 *  上传多张图片
		 *  TODO 等服务器支持多传之后再改
		 */
		uploadMultipleImages() {},

		/**
		 *  上传单张图片
		 *
		 *  image：图片的file对象
		 */
		uploadSingleImage(image) {
			return new Promise((resolve, reject) => {
				var formData = new FormData();
				formData.append(this.fieldName, image);
				formData.append('type', 'image');
				$.ajax({
					url: this.url,
					type: 'POST',
					dataType: 'JSON',
					cache: false,
					data: formData,
					processData: false,
					contentType: false,
					success: res => {
						resolve(res);
					},
					error: function (err) {
						reject(err);
					}
				});
			});
		},

		uploadSingleImageOSS(image) {
			return new Promise((resolve, reject) => {
				this.$store
					.dispatch('ossFileUploadNew', {
						options: {
							file: image,
							type: 'img'
						}
					})
					.then(res => {
						resolve(res);
					})
					.catch(err => {
						reject({ err });
					});
			});
		},
		/**
		 *  上传单张图片（OCR）
		 *
		 *  image：图片的file对象
		 */
		uploadSingleImageOCR(image) {
			return new Promise((resolve, reject) => {
				this.showTooltip({ msg: this.loadingMsg, img: OCR_LOADING, className: 'm-center-img', time: 0 });
				this.identifyBusinessCard({
					options: {
						file: image,
						type: 'img'
					}
				})
					.then(res => {
						if (this.handleHideTip) this.hideTooltip();
						resolve(res);
					})
					.catch(err => {
						reject({ err });
					});
			});
		},

		/**
		 *  解析图片
		 */
		parseImages(files) {
			if (this.lrzOptions) {
				return this.compressImages(files);
			} else {
				return this.readImages(files);
			}
		},

		/**
		 *  压缩图片
		 */
		compressImages: function (files) {
			let promises = [];
			for (let i = 0; i < files.length; i++) {
				promises.push(
					new Promise(r => {
						imageConversion
							.compressAccurately(files[i], {
								size: 500,
								accuracy: 0.9
							})
							.then(res => {
								blobToBase64(res).then(base64 => {
									r({ blob: res, base64, name: files[i].name });
								});
							});
					})
				);
			}
			return new Promise((resolve, reject) => {
				let images = [];
				Promise.all(promises)
					.then(res => {
						res.forEach(v => {
							res = new File([v.blob], v.name, { type: v.blob.type, lastModified: Date.now() });
							images.push({ file: res, src: v.base64, compress: true });
						});
						resolve(images);
					})
					.catch(e => {
						reject(e);
					});
			});
		},

		/**
		 *  读取图片
		 */
		readImages(files) {
			return new Promise((resolve, reject) => {
				let images = [];
				for (var i = 0; i < files.length; i++) {
					let reader = new FileReader();
					!(function (j) {
						reader.onload = function (e) {
							images[j] = { file: files[j], src: e.target.result, compress: false };
							if (j === files.length - 1) {
								resolve(images);
							}
						};
					})(i);
					// 开启压缩
					reader.readAsDataURL(files[i]);
				}
			});
		}
	}
};
</script>

<style lang="css">
.upload-button{position: relative;display: inline-block;overflow: hidden;}
.upload-button input{position:absolute;left: 0rem; top: 0rem;opacity: 0.0;-ms-filter: 'alpha(opacity=0)';font-size: 0.5rem;}
</style>
